export class TabHeaderItem {
  baseRoute?: string;
  label?: string;
  disabled?: boolean;
  pipes?: string[];
}
